import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Root from './Root.vue'
import Home from '../views/Home.vue'
import Start from '../views/Start.vue'
import Terms from '../views/Terms.vue'
import ThankYou from '../views/ThankYou.vue'
import a404 from '../views/a404.vue'
import i18n from '../i18n.js'
import { SUPPORTED_LOCALES } from '../locales/locales.js'
import en from '../locales/en.json'
import de from '../locales/de.json'
import fr from '../locales/fr.json'
import es from '../locales/es.json'
import it from '../locales/it.json'
import sl from '../locales/sl.json'

Vue.use(VueRouter)

function getLocaleRegex () {
  let reg = ''
  SUPPORTED_LOCALES.forEach((locale, index) => {
    reg = `${reg}${locale.code}${index !== SUPPORTED_LOCALES.length - 1 ? '|' : ''}`
  })
  return `(${reg})`
}

// Route paths translated per locale
const routePaths = {
  en: {
    home: '',
    start: 'start',
    code: 'code/:code',
    terms: 'terms-conditions',
    thankYou: 'thank-you'
  },
  fr: {
    home: '',
    start: 'demarrer',
    code: 'code/:code',
    terms: 'conditions-generales',
    thankYou: 'merci'
  },
  de: {
    home: '',
    start: 'starten',
    code: 'code/:code',
    terms: 'agb',
    thankYou: 'danke'
  },
  es: {
    home: '',
    start: 'comenzar',
    code: 'code/:code',
    terms: 'terminos-condiciones',
    thankYou: 'gracias'
  },
  it: {
    home: '',
    start: 'inizia',
    code: 'code/:code',
    terms: 'termini-condizioni',
    thankYou: 'grazie'
  },
  sl: {
    home: '',
    start: 'zacetek',
    code: 'code/:code',
    terms: 'pogoji-uporabe',
    thankYou: 'hvala'
  }
}

// Helper to get translated path for current locale
function getRoutePath (locale, key) {
  return (routePaths[locale] && routePaths[locale][key]) || routePaths.en[key]
}

// Generate routes for the current locale
function generateRoutes (locale) {
  return [
    {
      path: getRoutePath(locale, 'home'),
      name: 'Home',
      component: Home
    },
    {
      path: getRoutePath(locale, 'start'),
      name: 'Start',
      component: Start
    },
    {
      path: getRoutePath(locale, 'code'),
      name: 'Code',
      component: Home
    },
    {
      path: getRoutePath(locale, 'terms'),
      name: 'TermsConditions',
      component: Terms
    },
    {
      path: getRoutePath(locale, 'thankYou'),
      name: 'ThankYou',
      component: ThankYou
    },
    {
      path: '*',
      name: '404',
      component: a404
    }
  ]
}

// Use the locale from the route param or default to 'en'
const routes = generateRoutes(
  (typeof window !== 'undefined' && window.location.pathname.split('/')[1]) ||
    'en'
)

const translations = {
  en,
  de,
  fr,
  es,
  it,
  sl
}

// Returns locale configuration
function getLocale (locale = 'en') {
  return SUPPORTED_LOCALES.find(loc => loc.code === locale)
}

// Custom push method to prepend locale for non-English routes
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  // If location is a named route, inject locale param if not present
  if (typeof location === 'object' && location.name) {
    const currentLocale = store.state.locale && store.state.locale.code ? store.state.locale.code : 'en'
    if (currentLocale !== 'en') {
      location.params = location.params || {}
      if (!location.params.locale) {
        location.params.locale = currentLocale
      }
    }
  }
  return originalPush.call(this, location, onResolve, onReject)
}

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: `/:locale${getLocaleRegex()}?`,
    component: Root,
    beforeEnter (to, from, next) {
      const locale = getLocale(to.params.locale)
      store.commit('SET_LOCALE', locale)
      store.commit('SET_INTERFACE_TEXTS', locale)
      store.dispatch('INIT_DATA')
      i18n.setLocaleMessage(locale.code, translations[locale.code])
      i18n.locale = locale.code
      next(vm => {
        vm.previousRoute = from
      })
    },
    children: routes
  }]
})

export default router
